var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3929 2.41323H13.0179V1.12751C13.0179 1.03912 12.9456 0.966797 12.8572 0.966797H11.7322C11.6438 0.966797 11.5715 1.03912 11.5715 1.12751V2.41323H6.42864V1.12751C6.42864 1.03912 6.35632 0.966797 6.26793 0.966797H5.14293C5.05453 0.966797 4.98221 1.03912 4.98221 1.12751V2.41323H1.60721C1.25163 2.41323 0.964355 2.7005 0.964355 3.05608V16.3954C0.964355 16.7509 1.25163 17.0382 1.60721 17.0382H16.3929C16.7485 17.0382 17.0358 16.7509 17.0358 16.3954V3.05608C17.0358 2.7005 16.7485 2.41323 16.3929 2.41323ZM15.5894 15.5918H2.41078V7.95787H15.5894V15.5918ZM2.41078 6.5918V3.85965H4.98221V4.82394C4.98221 4.91233 5.05453 4.98465 5.14293 4.98465H6.26793C6.35632 4.98465 6.42864 4.91233 6.42864 4.82394V3.85965H11.5715V4.82394C11.5715 4.91233 11.6438 4.98465 11.7322 4.98465H12.8572C12.9456 4.98465 13.0179 4.91233 13.0179 4.82394V3.85965H15.5894V6.5918H2.41078Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.93a551d72c36b014d54f686e122a544d.svg";
export { ForwardRef as ReactComponent };